(ns ballot-scout-v2-frontend.disposition-manager.subs
  (:require
   [ballot-scout-v2-frontend.disposition-manager.events :as e.disposition]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::upload
 (fn [db]
   (get-in db [e.disposition/ns-key :upload])))

(rf/reg-sub
 ::fetch-disposition-status
 (fn [db]
   (get-in db [e.disposition/ns-key :fetching-disposition :status])))

(rf/reg-sub
 ::data
 (fn [db]
   (get-in db [e.disposition/ns-key :data])))

(rf/reg-sub
 ::disposition-data
 :<- [::subs/current-disposition]
 :<- [::data]
 (fn [[dispo data]]
   (get data (:disposition/id dispo))))

(rf/reg-sub
 ::headers
 :<- [::subs/current-disposition]
 :<- [::disposition-data]
 (fn [[dispo dispo-data]]
   (when dispo
     (let [{:keys [status headers]} (:header-state dispo-data)]
       (when-not status
         (rf/dispatch [::e.disposition/fetch-headers dispo]))
       headers))))

(defn phases [{:disposition/keys [phase] :as dispo}]
  (concat
   [{:phase :disposition-phase/upload-file
     :label "Upload File"}
    {:phase :disposition-phase/match-fields
     :label "Match Fields"}]
   (if (= (e.disposition/phase-mappings phase) :disposition-phase/canceled)
     [{:phase :disposition-phase/canceled
       :label "Canceled"}]
     [{:phase :disposition-phase/preview
       :label "Preview"}
      (cond
        (:disposition/completed-ts dispo)
        {:phase :disposition-phase/final
         :label "Disposition Completed!"}

        (:disposition/started-ts dispo)
        {:phase :disposition-phase/processing
         :label "Disposition in Progress"}

        :else
        {:phase :disposition-phase/final
         :label "Process Disposition"})])))

(rf/reg-sub
 ::current-disposition-phases
 :<- [::subs/current-disposition]
 (fn [dispo]
   (phases dispo)))

(rf/reg-sub
 ::list-state
 (fn [db]
   (get-in db [e.disposition/ns-key :list-state])))
